import { AdminFeature } from '@website/components/admin/AdminFeature';
import Credit from '@website/components/me/userID/Credit';
import PriceFormat from '@website/components/utilities/PriceFormat';
import { UserDashboardQuery } from '@website/types/graphqlOperations';
import Link from 'next/link';
import { Accordion, Alert, Table } from 'react-bootstrap';
import { ApplyCreditToUserForm } from './ApplyCreditsForm';
import CreditHistoryTable from './CreditsHistory';
import CustomerCreditHistory from './CustomerCreditHistory';

type Props = {
  credits: UserDashboardQuery['user']['credits'];
  userID: string;
  refreshUser: () => void;
};

/**
 * Credits list & admin add form
 */
export function Credits({ userID, credits, refreshUser }: Props) {
  // remove credits with 0 amount
  const filteredCredits = credits.filter((c) => c.amountZD > 0);

  return (
    <>
      {filteredCredits && filteredCredits.length > 0 ? (
        <>
          <Table>
            <tbody>
              {filteredCredits.map((credit) => (
                <Credit
                  userID={userID}
                  credit={credit}
                  key={credit.currency}
                  refreshUser={refreshUser}
                />
              ))}
            </tbody>
          </Table>
          <Alert variant="info">
            <Alert.Heading>How do I spend my credits?</Alert.Heading>
            <p>
              Your credits can be used on the deposit only (not the balance),
              for any trip. To use them, simply click book on a trip page and
              they will show up when you checkout. If they don't show up when
              you checkout, please <Link href="/help/contact">contact us</Link>.
            </p>
          </Alert>
        </>
      ) : (
        <p> You have no credits.</p>
      )}
      <AdminFeature>
        <ApplyCreditToUserForm refreshUser={refreshUser} userID={userID} />
      </AdminFeature>

      <CustomerCreditHistory credits={credits} />

      <AdminFeature>
        <h5>Credit History</h5>
        {credits.length > 0 ? (
          <Accordion defaultActiveKey={credits[0].currency}>
            {credits.map((credit) => (
              <Accordion.Item eventKey={credit.currency} key={credit.currency}>
                <Accordion.Header>
                  {credit.currency} (Current Balance:{' '}
                  <span className="ps-2">
                    <PriceFormat
                      amount={credit.amountZD}
                      currencyIso={credit.currency}
                    />
                  </span>
                  )
                </Accordion.Header>
                <Accordion.Body className="p-0">
                  <CreditHistoryTable creditHistory={credit.history.items} />
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        ) : (
          <p>No credit history</p>
        )}
      </AdminFeature>
    </>
  );
}
